__webpack_require__.p = "/social-media-calculator/";